const existColors = ['#F7CCD4', '#D7ECE4', '#D4E1FB', '#DCCCF7', '#EADCCC', '#FFCCE4', '#FFD4AE', '#BAEEFF', '#F1D4FC', '#CCF7CE', '#CCF9F1', '#E5FF97', '#F9F7AC', '#E9CFCF']

export const getColorByName = (() => {
	const colorMap = {}
	const usedColors = new Set()

	return (name) => {
		if (!name) return existColors[0]

		if (colorMap[name]) {
			return colorMap[name]
		}

		let hash = 0
		for (let i = 0; i < name.length; i++) {
			hash = hash + name.charCodeAt(i)
		}

		let index = hash % existColors.length

		let attempts = 0
		while (usedColors.has(index) && attempts < existColors.length) {
			index = (index + 1) % existColors.length
			attempts++
		}

		if (attempts >= existColors.length) {
			index = hash % existColors.length
		}

		const color = existColors[index]
		usedColors.add(index)
		colorMap[name] = color

		return color
	}
})()
